export enum Target {
	Shared = 'Shared',
	Custom = 'Custom',
}
